import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

export const futureTravelWithin2Years: AnswerPathTreeNode = {
  path: 'futureTravelWithin2Years',
  nodeId: 'lifestyle-travel-future-details-within-2years',
};
